/**
 * Application constants
 */

export const APP_NAME = 'Baú da Gata';
export const APP_DESCRIPTION = 'Brechó online com roupas e acessórios de segunda mão';

/**
 * Product categories
 */
export const CATEGORIES = {
  ALL: 'todos',
  CLOTHES: 'roupas',
  ACCESSORIES: 'acessorios',
  SHOES: 'calcados',
  BAGS: 'bolsas',
  OTHER: 'outros'
};

/**
 * Category labels (for display)
 */
export const CATEGORY_LABELS = {
  [CATEGORIES.ALL]: 'Todos',
  [CATEGORIES.CLOTHES]: 'Roupas',
  [CATEGORIES.ACCESSORIES]: 'Acessórios',
  [CATEGORIES.SHOES]: 'Calçados',
  [CATEGORIES.BAGS]: 'Bolsas',
  [CATEGORIES.OTHER]: 'Outros'
};

/**
 * Product sizes
 */
export const SIZES = {
  PP: 'PP',
  P: 'P',
  M: 'M',
  G: 'G',
  GG: 'GG',
  XGG: 'XGG',
  UNIQUE: 'Único'
};

/**
 * Product conditions
 */
export const CONDITIONS = {
  NEW: 'Novo',
  LIKE_NEW: 'Seminovo',
  GOOD: 'Bom estado',
  FAIR: 'Regular'
};

/**
 * Theme colors
 */
export const COLORS = {
  PRIMARY: '#ab26bd',
  PRIMARY_LIGHT: '#c94ddb',
  PRIMARY_DARK: '#8a1e99',
  SECONDARY: '#6c757d',
  SUCCESS: '#28a745',
  ERROR: '#dc3545',
  WARNING: '#ffc107',
  INFO: '#17a2b8'
};

/**
 * Breakpoints for responsive design
 */
export const BREAKPOINTS = {
  SM: 480,
  MD: 768,
  LG: 1024,
  XL: 1280
};

/**
 * Animation durations
 */
export const DURATIONS = {
  FAST: 150,
  NORMAL: 300,
  SLOW: 500
};

/**
 * Z-index layers
 */
export const Z_INDEX = {
  DROPDOWN: 100,
  HEADER: 200,
  MODAL_BACKDROP: 300,
  MODAL: 400,
  TOAST: 500,
  TOOLTIP: 600
};

/**
 * Local storage keys
 */
export const STORAGE_KEYS = {
  THEME: 'bau-da-gata-theme',
  LANGUAGE: 'bau-da-gata-language',
  COOKIE_CONSENT: 'cookie-consent',
  FAVORITES: 'bau-da-gata-favorites'
};

/**
 * API endpoints (if needed in future)
 */
export const ENDPOINTS = {
  INVENTORY: '/api/inventory',
  CONTACT: '/api/contact'
};
